(function(){
  if (window.__hofInit) return; window.__hofInit = true;
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.hof-film__play');
    if (btn) {
      var fig = btn.closest('.hof-film'), v = fig.querySelector('video');
      document.querySelectorAll('.hof-film video').forEach(function(o){ if (o !== v) o.pause(); });
      if (!v.getAttribute('src')) { var im = fig.querySelector('.hof-film__poster'); if (im && !v.poster) v.poster = im.currentSrc || im.src; v.setAttribute('src', (v.dataset.srcSm && window.innerWidth < 750) ? v.dataset.srcSm : v.dataset.src); }
      v.controls = true; fig.classList.add('is-playing');
      var p = v.play(); if (p && p.catch) p.catch(function(){});
      return;
    }
    var buy = e.target.closest && e.target.closest('[data-hof-buy]');
    if (buy) {
      var f = document.querySelector('form[action*="/cart/add"]:not([id*="sticky" i])') || document.querySelector('form[action*="/cart/add"]');
      if (f) { e.preventDefault(); f.scrollIntoView({behavior:'smooth', block:'center'}); var sb = f.querySelector('[type=submit],[name=add]'); if (sb) setTimeout(function(){ sb.focus({preventScroll:true}); }, 600); }
      return;
    }
    var tab = e.target.closest && e.target.closest('.hof__tab');
    if (tab) {
      var list = tab.parentNode, root = list.parentNode;
      list.querySelectorAll('.hof__tab').forEach(function(t){
        var on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      root.querySelectorAll('.hof-film video').forEach(function(v){ v.pause(); });
    }
  });
  document.addEventListener('keydown', function(e){
    var tab = e.target.closest && e.target.closest('.hof__tab'); if (!tab) return;
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('.hof__tab'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var n = tabs[(i + tabs.length) % tabs.length]; n.focus(); n.click(); e.preventDefault();
  });
})();

/* Rotating owner faces on multi-owner film covers. Loads nothing until the film is on screen, after page load. */
(function(){
  if (window.__hofRot) return; window.__hofRot = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function parse(r){ return r.getAttribute('data-rot').split(',').map(function(x){ var p = x.trim().split('|'); return { f: p[0], n: p[1] || '' }; }); }
  function label(r, i){ var l = r.parentNode.querySelector('.hof-film__nm'); if (l) l.textContent = r.__items[i].n; }
  function build(r){
    if (r.__imgs) return;
    var w = Math.min(1200, Math.max(400, Math.ceil(r.clientWidth * (window.devicePixelRatio || 1) / 200) * 200));
    r.__imgs = [null];
    r.__items.slice(1).forEach(function(it){
      var im = new Image(); im.alt = ''; im.decoding = 'async';
      im.src = '/cdn/shop/files/' + it.f + '?width=' + w;
      r.appendChild(im); r.__imgs.push(im);
    });
    r.__i = 0;
  }
  function stop(r){ if (r.__t) { clearInterval(r.__t); r.__t = null; } }
  function start(r){
    var fig = r.closest('.hof-film');
    if (r.__t || fig.classList.contains('is-playing')) return;
    build(r);
    r.__t = setInterval(function(){
      if (fig.classList.contains('is-playing')) { stop(r); return; }
      var n = (r.__i + 1) % r.__items.length, im = r.__imgs[n];
      if (im && !(im.complete && im.naturalWidth)) return;
      r.__imgs.forEach(function(x, k){ if (x) x.classList.toggle('on', k === n); });
      r.__i = n; label(r, n);
    }, 2600);
  }
  function setup(){
    var els = Array.prototype.slice.call(document.querySelectorAll('.hof-film__rot[data-rot]'));
    if (!els.length) return;
    els.forEach(function(r){ r.__items = parse(r); label(r, 0); });
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ var r = e.target; r.__vis = e.isIntersecting; if (e.isIntersecting && !document.hidden) start(r); else stop(r); });
    }, { threshold: 0.35 });
    els.forEach(function(r){ io.observe(r); });
    document.addEventListener('visibilitychange', function(){ els.forEach(function(r){ if (document.hidden) stop(r); else if (r.__vis) start(r); }); });
  }
  function idle(){ (window.requestIdleCallback || function(f){ setTimeout(f, 300); })(setup, { timeout: 3000 }); }
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
})();

/* GA4 engagement events (Oct 2026). Sends to the store's GA4 tag only when it is on the page and analytics consent allows it.
   video_start / video_progress (25, 50, 75) / video_complete for owner films; select_content for question tabs,
   owner-story links and the film-section buy buttons. */
(function(){
  if (window.__hofGa) return; window.__hofGa = true;
  var ga = null;
  function gaId(){
    if (ga !== null) return ga;
    var s = document.querySelector('script[src*="googletagmanager.com/gtag/js?id=G-"]');
    var m = s && s.src.match(/id=(G-[A-Z0-9]+)/);
    ga = m ? m[1] : '';
    return ga;
  }
  function allowed(){
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') { try { return !!cp.analyticsProcessingAllowed(); } catch (e) {} }
    return true;
  }
  function send(name, p){
    if (typeof window.gtag !== 'function' || !allowed()) return;
    p = p || {};
    p.page_type = (window.theme && window.theme.pageType) || '';
    if (gaId()) p.send_to = gaId();
    try { window.gtag('event', name, p); } catch (e) {}
  }
  function where(el){
    if (el.closest('dialog')) return 'proof-popup';
    var sec = el.closest('[id^="shopify-section"]');
    return sec ? sec.id.replace('shopify-section-', '').replace(/^template--\d+__/, '').slice(0, 60) : '';
  }
  function film(v){
    var src = v.getAttribute('data-src') || v.currentSrc || '';
    var m = src.match(/\/([^\/?]+)\.(mp4|webm|m3u8)/i);
    return { video_title: (v.getAttribute('aria-label') || '').slice(0, 100), video_url: m ? m[1].slice(0, 80) : '', video_provider: 'shopify', film_section: where(v) };
  }
  function isFilm(t){ return t && t.tagName === 'VIDEO' && t.closest && t.closest('.hof-film'); }
  document.addEventListener('play', function(e){
    var v = e.target; if (!isFilm(v) || v.__gaStart) return;
    v.__gaStart = true; v.__gaMarks = {};
    send('video_start', film(v));
  }, true);
  document.addEventListener('timeupdate', function(e){
    var v = e.target; if (!isFilm(v) || !v.__gaMarks || !v.duration) return;
    var pct = v.currentTime / v.duration * 100;
    [25, 50, 75].forEach(function(q){
      if (pct >= q && !v.__gaMarks[q]) { v.__gaMarks[q] = true; var p = film(v); p.video_percent = q; send('video_progress', p); }
    });
  }, true);
  document.addEventListener('ended', function(e){
    var v = e.target; if (!isFilm(v) || v.__gaDone) return;
    v.__gaDone = true; var p = film(v); p.video_percent = 100; send('video_complete', p);
  }, true);
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('.hof__tab, a[href*="/blogs/case-studies"], [data-hof-buy], .hof__btn, .hco__link');
    if (!t) return;
    var num = t.querySelector('.hof__num');
    var label = (t.textContent || '').replace(num ? num.textContent : '', '').replace(/\s+/g, ' ').trim().slice(0, 100);
    var type = t.classList.contains('hof__tab') ? 'owner_question_tab'
      : (t.matches('a[href*="/blogs/case-studies"]') ? 'owner_story_link' : 'film_section_button');
    send('select_content', { content_type: type, item_id: label, film_section: where(t), link_url: (t.getAttribute('href') || '').slice(0, 100) });
  }, true);
})();
